import React, { useState, useEffect } from 'react';
import './Services.css';
import ServiceCard from '../UI/ServiceCard';
import { servicesData } from '../../assets/data/servicesData';
import MyLottie from '../MyLottie/MyLottie';
import { useTranslation } from 'react-i18next';

const Services = ({ title }) => {
  const { t } = useTranslation();
  const [activeCardIndex, setActiveCardIndex] = useState(null);

  useEffect(() => {
    if (window.innerWidth > 440) return;

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.6,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const index = Number(entry.target.dataset.index);
        if (entry.isIntersecting) {
          setActiveCardIndex((prevIndex) =>
            prevIndex !== index ? index : prevIndex
          );
        } else {
          setActiveCardIndex((prevIndex) =>
            prevIndex === index ? null : prevIndex
          );
        }
      });
    }, options);

    const cards = document.querySelectorAll('.service-card');
    cards.forEach((card, index) => {
      card.dataset.index = index;
      observer.observe(card);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section className="services">
      <div className="services__container container">
        {title !== false && (
          <h2 className="services__title main-title">
            {title || t('services')}
          </h2>
        )}
        <div className="services__cards">
          {servicesData(t).map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              technologies={service.technologies || []}
              aiCollaboration={service.aiCollaboration || ''}
              className={`service-card ${
                activeCardIndex === index ? 'active' : ''
              }`}
            />
          ))}
        </div>
        <MyLottie className="service-anima" />
      </div>
    </section>
  );
};

export default Services;
